import { render } from "./PrepaidCard.vue?vue&type=template&id=0d516b79&scoped=true&ts=true"
import script from "./PrepaidCard.vue?vue&type=script&lang=ts"
export * from "./PrepaidCard.vue?vue&type=script&lang=ts"

import "./PrepaidCard.vue?vue&type=style&index=0&id=0d516b79&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/git_node_build_images_push_anjinq_test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d516b79"]])

export default __exports__